import { type ReactElement, type PropsWithChildren } from 'react'
import { isNotEmpty } from '@terros/common'
import { Text, Title } from '@mantine/core'
import { ColorPrimitives, SizePrimitives, type MaterialSymbolType } from '@front/model'
import { MaterialSymbolIcon } from '../terros/icon/MaterialSymbolIcon'

type Props = PropsWithChildren<{
  icon?: MaterialSymbolType
  title: string
  description?: string
}>

export const PageHero = ({ icon, title, description, children }: Props): ReactElement => {
  return (
    <div className='flex grow flex-col items-center justify-center gap-4 text-center'>
      {icon && (
        <div className='bg-default-hover p-2xl flex aspect-square items-center justify-center rounded-full'>
          <MaterialSymbolIcon color={ColorPrimitives.neutral[400]} icon={icon} size={SizePrimitives['16']} />
        </div>
      )}
      <Title order={3}>{title}</Title>
      {isNotEmpty(description) && <Text>{description}</Text>}
      {children}
    </div>
  )
}
